<template>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Prezzo iniziale" text="Prezzo iniziale"></localized-text>
        </label>
        <input class="form-control" type="text" v-model="localValue.fullPrice" />
    </div>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Prezzo finale" text="Prezzo finale"></localized-text>
        </label>
        <input class="form-control" type="text" v-model="localValue.finalPrice" />
    </div>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Valuta" text="Valuta"></localized-text>
        </label>
        <select class="form-control" v-model="localValue.currency">
            <option value="€">€</option>
            <option value="AuraCoin">AuraCoin</option>
        </select>
    </div>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Note" text="Note"></localized-text>
        </label>
        <input class="form-control" type="text" v-model="localValue.note" />
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import { Options } from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';
import WithModel from '@/mixins/withModel';

@Options({})
export default class priceBlock extends Mixins(WithModel) {
    declare localValue: OM.PriceBlock;

    created(){
        if(!this.localValue.fullPrice){
            this.localValue.fullPrice = "";
        }
        if(!this.localValue.finalPrice){
            this.localValue.finalPrice = "";
        }
        if(!this.localValue.currency){
            this.localValue.currency = "";
        }
        if(!this.localValue.note){
            this.localValue.note = "";
        }
    }

    @Watch('localValue.isFullWidth')
    @Watch('localValue.marginBottom')
    @Watch('localValue.fullPrice')
    @Watch('localValue.finalPrice')
    @Watch('localValue.currency')
    @Watch('localValue.note')
    onChange(){
        this.localValue.htmlText = `
            <div class="priceBlock ${(!this.localValue.isFullWidth ? 'px-4' : '')} ${('mb-' + this.localValue.marginBottom)}">`;
            if(this.localValue.fullPrice){
                this.localValue.htmlText += `
                <div class="left">
                    ${this.localValue.currency} ${this.localValue.fullPrice}
                    <img src="./img/redcross.png" />
                </div>`;
            }
            this.localValue.htmlText += `
                <div class="right">
            `;
            if(this.localValue.finalPrice){
                this.localValue.htmlText += `
                    <div class="finalPrice">
                        ${this.localValue.currency} ${this.localValue.finalPrice}
                    </div>
                `;
                if(this.localValue.note){
                    this.localValue.htmlText += `
                        <div class="underPrice">
                            ${this.localValue.note}
                        </div>
                    `;
                }
            }
            this.localValue.htmlText += `</div></div>`;
    }
}
</script>
